import { create } from 'zustand';
import { persist } from 'zustand/middleware';
// Only the user object is persisted to localStorage; the access token is held
// in memory so a stolen-XSS payload can't simply read it. On reload we ask
// the backend to refresh from the httpOnly cookie.
export const useAuthStore = create()(persist((set) => ({
    accessToken: null,
    user: null,
    setSession: (accessToken, user) => set({ accessToken, user }),
    setAccessToken: (accessToken) => set({ accessToken }),
    setUser: (user) => set({ user }),
    clear: () => set({ accessToken: null, user: null }),
}), {
    name: 'arshe.auth',
    partialize: (s) => ({ user: s.user }),
}));
